<template>
  <div class="content">
    <!-- <b-row class="mb-3">
      <b-col>
        <img src="@/assets/images/backgrounds/account.jpg" alt="packages" class="img-fluid" />
      </b-col>
    </b-row> -->
    <b-row>
      <b-col md="12" class="py-3 bg-light border mb-3 rounded">
        <b-row>
          <b-col md="7">
            <h5 class="result-summary rounded" v-translate>Company details</h5>
            <b-card>
              <b-list-group flush class="list-dense">
                <b-list-group-item>
                  <span class="user-details" v-translate>Agency code:</span><span > {{ userData.code }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Agency name:</span><span> {{ userData.name }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Commision:</span><span> {{ userData.groupName }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Company name:</span><span >{{ userData.companyName }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Cod fiscal:</span><span> {{ userData.vatNo }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Nr. Reg Comertului:</span><span > {{ userData.companyNo }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Address:</span><span> {{ userData.address }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Account:</span><span> {{ userData.bankAccount }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Bank:</span><span> {{ userData.bankName }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate>Email:</span><span><a :href="'mailto:' + userData.email">{{ userData.email }}</a></span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-details" v-translate >Phone:</span><span> {{ userData.tel }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>
          <b-col md="5">
            <h5 class="result-summary rounded" v-translate>User details</h5>
            <b-list-group>
              <b-list-group-item>
                <span class="user-name" v-translate>Login name:</span><span> {{ userData.username }}</span>
              </b-list-group-item>
              <b-list-group-item>
                <span class="user-name" v-translate>Name:</span><span> {{ userData.title }} {{ userData.fname }} {{ userData.lname }}</span>
              </b-list-group-item>
              <b-list-group-item>
                <span class="user-name" v-translate>Email:</span><span> <a :href="'mailto:' + userData.email"> {{ userData.email }}</a></span>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
